<template>
    <div
        class="cursor-pointer flex flex-col justify-center items-center landscape:flex-row p-4 relative overflow-hidden">
        <img v-for="avaria in croquisAvarias" :key="avaria.nome" class="w-72 h-60"
            :class="avaria.tipoVeiculo == tipoCaminhao ? 'rotate-[20deg]' : ''" :src="avaria.imagem" alt="">
        <div v-if="exibirIndicador" class="bg-azul-info bg-opacity-55 rounded-full absolute">
            <img class="relative" src="@/assets/clique.gif" alt="">
        </div>
        <div v-if="semAvaria" class="absolute flex justify-evenly flex-wrap -rotate-45">
            <span v-for="n in 150" :key="n" class="relative text-[#2828288e] text-base opacity-50">Sem Avaria
                &nbsp;</span>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'CroquiAvaria',
    props: {
        croquisAvarias: {
            type: Array,
            required: true
        },
        tipoCaminhao: {
            type: String,
            required: true
        },
        exibirIndicador: {
            type: Boolean,
            default: false
        },
        semAvaria: {
            type: Boolean,
            default: false
        }
    }
});

</script>